module.exports = __webpack_public_path__ + "img/logo.79e97781.jpg";